import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, DownloadSimple } from "@phosphor-icons/react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1696943444991-def9485f89f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkZXRyb2l0JTIwc2t5bGluZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODI5Njk3MzF8MA&ixlib=rb-4.1.0&q=85";

export const Hero = () => (
  <section data-testid="hero-section" className="relative min-h-screen flex items-end overflow-hidden bg-[#090A0C]">
    <img src={HERO_IMG} alt="Detroit skyline at night" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#090A0C] via-[#090A0C]/70 to-[#003366]/40" />
    <div
      className="absolute inset-0 blueprint-grid hero-grid-pan opacity-50"
      style={{ ["--grid-line" as string]: "rgba(120,170,255,0.10)" }}
    />

    <div className="relative w-full max-w-7xl mx-auto px-5 sm:px-8 pb-20 md:pb-28 pt-40">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="font-mono-tech text-[11px] md:text-xs tracking-[0.3em] uppercase text-[#FFD60A] mb-6"
      >
        Veteran-Led · Detroit-Built · Federally Ready
      </motion.p>

      <motion.h1
        initial={{ opacity: 0, y: 28 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
        data-testid="hero-headline"
        className="font-heading font-medium text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-white leading-[1.02] max-w-4xl"
      >
        Building the future.
        <br />
        <span className="text-white/50">Restoring the legacy.</span>
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.35 }}
        className="mt-7 text-base md:text-lg text-white/65 max-w-2xl leading-relaxed"
      >
        FOSCHE, LLC is a service-disabled veteran-owned construction, redevelopment, and infrastructure firm
        delivering mission-critical projects for federal agencies, developers, and communities across Detroit and beyond.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.5 }}
        className="mt-10 flex flex-wrap gap-4"
      >
        <Link
          to="/quote"
          data-testid="hero-quote-btn"
          className="group inline-flex items-center gap-3 px-7 py-4 bg-[#003366] text-white text-sm font-medium tracking-wide transition-all hover:bg-[#FFCC00] hover:text-black"
        >
          Request a Quote
          <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
        </Link>
        <a
          href="/FOSCHE-Capability-Statement.pdf?v=3"
          download
          data-testid="hero-capability-btn"
          className="inline-flex items-center gap-3 px-7 py-4 border border-white/30 text-white text-sm font-medium tracking-wide transition-all hover:border-[#FFD60A] hover:text-[#FFD60A]"
        >
          <DownloadSimple size={16} />
          Capability Statement
        </a>
      </motion.div>
    </div>
  </section>
);
